import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const postTokens = ({ username, password }) => httpClient.post(`${ENDPOINT_API.OAUTH_TOKEN}`, {
	grant_type: 'password',
	client_id: process.env.VUE_APP_CLIENT_ID,
	client_secret: process.env.VUE_APP_CLIENT_SECRET,
	scope: '*',
	username,
	password,
});

const deleteRevorkToken = ({ jti }) => httpClient.delete(`${ENDPOINT_API.OAUTH_TOKEN_REVORK}/${jti}`);

export {
	postTokens,
	deleteRevorkToken,
};
